module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/past-events/past-events.component.scss
// module id = ./src/app/past-events/past-events.component.scss
// module chunks = main